import { memo } from 'react';
import Badge from './Badge';
import './styles/environmentBadge.css';

const getEnvironmentBadgeClass = (env: string) => {
  switch (env) {
    case 'Dev':
      return 'badge-env-dev';
    case 'SIT':
      return 'badge-env-sit';
    case 'QA':
      return 'badge-env-qa';
    case 'UAT':
      return 'badge-env-uat';
    case 'Non-Prod':
      return 'badge-env-nonprod';
    default:
      return 'badge-env-dev';
  }
};

const EnvironmentBadge = memo(({ environment }: { environment: string }) => {
  return (
    <Badge
      text={environment}
      className={getEnvironmentBadgeClass(environment)}
    />
  );
});

export default EnvironmentBadge;
